<script lang="ts" setup>
interface IKeywordWithHighlightProps {
  search?: string
  text?: string
}

const props = defineProps<IKeywordWithHighlightProps>()

// Escapes all special regex characters.
const escapedSearch = props.search?.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&')
const splitBySpaces = escapedSearch?.split(/\s/g)
const pattern = new RegExp(`(${splitBySpaces?.join('|')})`, 'ig')
const parts = props.text?.split(pattern)

const partsForHighlighting = new Set(splitBySpaces?.map((part) => part.toLocaleLowerCase()))
</script>

<template>
  <span class="keyword">
    <span
      v-for="(part, i) in parts"
      :key="i"
      :class="{
        'text-sm': true,
        highlighted: partsForHighlighting.has(part.toLocaleLowerCase()),
      }">
      {{ part }}
    </span>
  </span>
</template>

<style>
.keyword .highlighted {
  font-weight: 700;
  color: theme('colors.brand.primary');
}
</style>
